import { GetComponentProps, history, request, useActions, useBook, useFile, useInPreview, useModel } from 'topwrite';
import { useEffect, useMemo } from 'react';
import { useSubBook } from '@/lib/sub-book';

export default function Activate({ children }: GetComponentProps<'activate'>) {

    const { setHandler } = useActions('search');
    const { summary } = useBook();
    const preview = useInPreview();
    const subBook = useSubBook();
    const file = useFile();
    const [{ lfs }, { intercept, fetch }] = useModel('page');

    useEffect(() => {
        if (lfs) {
            subBook.setLfsFiles(lfs.files);
        }
    }, []);

    useMemo(() => {
        intercept(({ request }) => {
            request.use(subBook.interceptRequest());
        });
    }, []);

    useEffect(() => {
        if (!preview && file) {
            //TODO 检查服务端是否支持全文搜索
            setHandler(async (keyword) => {
                try {
                    const { data } = await request.post<any[]>(file.relative('search'), {
                        keyword,
                        ids: subBook.ids
                    });

                    return data.map((item) => {
                        if (subBook.ids.includes(item.book)) {
                            item.path = subBook.resolvePath(item.book, item.path);
                        }

                        return {
                            title: item.title,
                            path: item.path
                        };
                    });
                } catch {
                    return [];
                }
            });
        }
    }, [file]);

    const articleMatch = useMemo(() => {
        const article = summary.getArticle(article => article.getPath() === file.path);

        return article || file.path === 'index.html';
    }, [file]);

    useEffect(() => {
        if (articleMatch) {
            if (file.content === undefined) {
                //重新加载
                fetch(history.location.pathname);
            }
        } else {
            const id = subBook.resolveBook(file.path);
            if (id) {
                const article = summary.getArticle(() => {
                    return true;
                }, (part) => part.getMetadata('reference') === id);

                if (article) {
                    history.replace(file.relative(article.path));
                    return;
                }
            }

            //跳转首页
            history.replace(file.relative('/'));
        }
    }, []);

    if (!articleMatch) {
        return null;
    }

    return children;
}
